
import { addCreditParty, updateZj } from '@/api/jfhl.js'
import { award, isAward } from '@/api/lottery'
import descStar from '@/assets/jfcj/desc_star.png'
import descBottom from '@/assets/jfcj/bottom_bg.png'
import AddressInfo from './address-info'
import HeaderDialog from './header-dialog'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
XDialog,
AddressInfo,
HeaderDialog
},
props: ['lotid'],
data () {
return {
showScratch: false,
desc_star: descStar,
desc_bottom: descBottom,
times: 0,
show: false,
msg: '',
showtouch: true,
context: '',
isaward: '',
zhongjiang: false,
lottery: true,
partyid: this.$route.params.partyid
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.init()
},
methods: {
showDialog () {
this.isAward()
},

isAward () {
isAward({
lotid: this.lotid,
openid: this.accountid
}).then(data => {
if (data.obj.isaward === 1) {
this.times = 0
this.showtouch = false
this.isaward = data.obj.isaward
this.showResult()
if (data.obj.iszhongjiang === 1) {
this.msg = data.obj.item
}
if (data.obj.iszhongjiang === 2) {
this.msg = '谢谢参与'
}
} else if (data.obj.isawardold === 2 && data.obj.iszhongjiang === 1) {
this.times = 0
} else {
this.times = 1
}
this.showScratch = true
})
},
getLottery () {
let _this = this
this.lottery = false
award({
lotid: this.lotid,
openid: this.accountid
}).then(data => {
if (data.obj.isaward === 1) {
this.isaward = data.obj.isaward
this.msg = data.obj.item
if (data.obj.item.indexOf('积分') !== -1) {
this.addJiFen(data.obj.item.replace(/[^0-9]/ig, ''))
}
updateZj({
partyid: this.partyid,
accountid: this.accountid
}).then(data => {
console.log(data)
})
} else if (data.obj.isaward === 2) {
this.$vux.alert.show({
content: '您已经抽过奖',
buttonText: '回到首页',
onHide () {
_this.$router.go(-1)
}
})
}
})
},

addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {
if (res.msg.indexOf('兑换成功') !== -1) {
this.$vux.toast.text('积分添加成功！')
} else {
this.$vux.toast.text('积分添加失败！')
}
})
},
back () {
this.showScratch = false
this.$router.go(-1)
},
address () {
this.showScratch = false
this.$refs.addressInfo.showDialog()
},
init () {
let canvas = document.getElementById('mask')
let context = canvas.getContext('2d')
context.fillStyle = '#d1d1d1'
context.fillRect(0, 0, 260, 120)
context.font = '26px arial'
context.fillStyle = '#666'
context.textAlign = 'center'
context.textBaseline = 'middle'
context.fillText('刮奖区', 130, 60)
context.globalCompositeOperation = 'destination-out'
this.context = context

canvas.addEventListener('touchstart', this.drawArcMouseHandle)
canvas.addEventListener('touchsend', event => {

this.removeEventListener('touchmove', this.mousemoveHandle)
})

canvas.addEventListener('touchmove', this.drawArcTouchHandle)
this.show = true
},

drawArcMouseHandle (event) {
event.preventDefault()
event.target.addEventListener('touchmove', this.mousemoveHandle)
},

mousemoveHandle (event) {
event.preventDefault()
this.drawArcByPoint(event.pageX, event.pageY)
},

drawArcTouchHandle (event) {
event.preventDefault()
var touch = event.touches[0]
this.drawArcByPoint(touch.pageX, touch.pageY - 200)
},



drawArcByPoint (x, y) {
this.context.beginPath()
this.context.stroke()
this.context.arc(
x - canvas.offsetLeft,
y - canvas.offsetTop,
15,
0,
Math.PI * 2
)
this.context.closePath()
this.context.fillStyle = '#ffffff'
this.context.fill()
this.checkComplete()
},

checkComplete () {
var imgData = this.context.getImageData(0, 0, 260, 120)
var pxData = imgData.data 
var len = pxData.length 
var count = 0 

for (var i = 0; i < len; i += 4) {
var alpha = pxData[i + 3] 
if (alpha < 10) {

count++
}
}
var percent = count / (len / 4) 

if (percent > 0.5) {
if (this.lottery) {
this.getLottery()
}
this.showResult()
}
},

showResult () {
this.context.clearRect(0, 0, 260, 120)
this.times = 0
if (this.isaward === 1) {
this.zhongjiang = true
}
}
}
}
